export default __webpack_public_path__ + "static/media/Convocatoria_PE2024.f93fc22d.pdf";